import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export interface ValidConfigurationState {
    basic?: boolean;
    settings?: boolean;
    accounting?: boolean;
    groups?: boolean;
    progressives?: boolean;
    specialPrizes?: boolean;
    globalJackpot?: boolean;
    mailingList?: boolean;
    mailSender?: boolean;
    sounds?: boolean;
    rtpProfiles?: boolean;
    megapot?: boolean;
}

const actionToValidIDMap = {
    //[ConfigurationsActionTypes.UPDATE_BASIC_CONFIG]: "basic",
    [ConfigurationsActionTypes.UPDATE_SETTINGS_CONFIG]: "settings",
    [ConfigurationsActionTypes.UPDATE_ACCOUNTING_CONFIG]: "accounting",
    [ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG]: "groups",
    [ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG_EMPTY]: "groups",
    [ConfigurationsActionTypes.UPDATE_PROGRESSIVES_CONFIG]: "progressives",
    [ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG]: "specialPrizes",
    [ConfigurationsActionTypes.UPDATE_GLOBAL_JACKPOT_CONFIG]: "globalJackpot",
    [ConfigurationsActionTypes.UPDATE_SOUNDS_CONFIG]: "sounds",
    [ConfigurationsActionTypes.UPDATE_RTP_PROFILES_CONFIG]: "rtpProfiles",
    [ConfigurationsActionTypes.UPDATE_MAILING_CONFIG]: "mailingList",
    [ConfigurationsActionTypes.UPDATE_MAIL_SENDER_CONFIG]: "mailSender",
    [ConfigurationsActionTypes.UPDATE_MEGAPOT_CONFIG]: "megapot"
};

export function configFormValid(
    state: ValidConfigurationState = {
        basic: true,
        settings: false,
        accounting: false,
        groups: false,
        progressives: false,
        specialPrizes: true,
        globalJackpot: false,
        mailingList: false,
        mailSender: false,
        sounds: true,
        rtpProfiles: true,
        megapot: false
    },
    action: Action
): ValidConfigurationState {
    switch (action.type) {
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return {
                basic: true,
                settings: false,
                accounting: false,
                groups: false,
                progressives: false,
                specialPrizes: true,
                globalJackpot: false,
                sounds: true,
                rtpProfiles: true,
                mailingList: false,
                mailSender: false,
                megapot: false
            };
        case ConfigurationsActionTypes.GET_CONFIGURATION_SUCCESS:
            return {
                basic: true,
                settings: true,
                accounting: true,
                groups: true,
                progressives: true,
                specialPrizes: true,
                globalJackpot: true,
                mailingList: true,
                sounds: true,
                rtpProfiles: true,
                mailSender: true,
                megapot: true
            };

        case ConfigurationsActionTypes.UPDATE_ACCOUNTING_CONFIG:
            // const { config } = action.payload;
            // const validDigits =
            //     config.system === 2 ? config.voucher_digits != null : true;
            return {
                ...state,
                accounting:
                    action.payload
                        .isValid /*config.system !== null && config.system !== undefined
                    && config.system !== "" && validDigits*/
            };
        case ConfigurationsActionTypes.UPDATE_BASIC_CONFIG:
        case ConfigurationsActionTypes.UPDATE_SETTINGS_CONFIG:
        case ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG:
        case ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG_EMPTY:
        case ConfigurationsActionTypes.UPDATE_PROGRESSIVES_CONFIG:
        case ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG:
        case ConfigurationsActionTypes.UPDATE_GLOBAL_JACKPOT_CONFIG:
        case ConfigurationsActionTypes.UPDATE_RTP_PROFILES_CONFIG:
        case ConfigurationsActionTypes.UPDATE_MAILING_CONFIG:
        case ConfigurationsActionTypes.UPDATE_MEGAPOT_CONFIG:
        case ConfigurationsActionTypes.UPDATE_MAIL_SENDER_CONFIG:
            return {
                ...state,
                [actionToValidIDMap[action.type]]: action.payload.isValid
            };
        case ConfigurationsActionTypes.CLEAR_VALID_PROG_SECTION:
            return {
                ...state,
                progressives: false
            };
        case ConfigurationsActionTypes.UPDATE_GROUPS_BASED_ON_GAME_TYPES:
            return {
                ...state,
                [actionToValidIDMap[
                    ConfigurationsActionTypes.UPDATE_GROUPS_CONFIG
                ]]: false
            };
        case ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_BASED_ON_BINGO_SETTINGS:
            return {
                ...state,
                [actionToValidIDMap[
                    ConfigurationsActionTypes.UPDATE_SPECIAL_PRIZES_CONFIG
                ]]: action.payload.actionToValidIDMap
            };
        case ConfigurationsActionTypes.CLEAR_VALID_SPECIAL_SECTION:
            return {
                ...state,
                specialPrizes: false
            };
        case ConfigurationsActionTypes.UPDATE_NECESSARY_VALIDS:
            if (action.payload.length == 3) {
                return {
                    ...state,
                    basic: true,
                    settings: true,
                    groups: true,
                    accounting: true,
                    progressives: true,
                    specialPrizes: true,
                    sounds: true,
                    globalJackpot: true,
                    mailSender: true,
                    mailingList: true
                };
            } else if (action.payload.length == 9) {
                return {
                    ...state,
                    sounds: true
                };
            } else if (action.payload.length == 8) {
                return {
                    ...state,
                    sounds: true,
                    globalJackpot: true
                };
            } else {
                return {
                    ...state
                };
            }
        default:
            return {
                ...state
            };
    }
}

export function configFormVisited(
    state: ValidConfigurationState = {},
    action: Action
): ValidConfigurationState {
    switch (action.type) {
        case ConfigurationsActionTypes.CLEAR_CONFIGURATION:
            return {
                basic: true,
                settings: false,
                accounting: false,
                groups: false,
                progressives: false,
                specialPrizes: false,
                globalJackpot: false,
                mailingList: false,
                mailSender: false,
                sounds: false,
                rtpProfiles: false,
                megapot: false
            };
        case ConfigurationsActionTypes.CONFIGURATION_VISITED_EDIT_MODE:
            return {
                basic: true,
                settings: true,
                accounting: true,
                groups: true,
                progressives: true,
                specialPrizes: true,
                globalJackpot: true,
                mailingList: true,
                mailSender: true,
                sounds: true,
                rtpProfiles: true,
                megapot: true
            };

        case ConfigurationsActionTypes.VISIT_CONFIG_SECTION:
            return {
                ...state,
                [actionToValidIDMap[action.payload.type]]: true
            };
        default:
            return state;
    }
}
